// extracted by mini-css-extract-plugin
export var copyright = "footer-module--copyright--Bg9Rz";
export var footer = "footer-module--footer--lU7l1";